import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from "chart.js";
import {useEffect, useMemo, useState} from "react";
import { Bar } from 'react-chartjs-2';
import {CHART_COLORS, NEGATIVE_CHART_COLORS} from "../consts/COLOR_SETS.js";
import "../style.css";
import {BaseChart} from "./BaseChart";

export const StackedChart = ({ data, dataSets, labels, title = "", isDataLoaded = false }) => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );

    const digestedData = useMemo(() => {
        if(data && isDataLoaded) {
            return {
                labels,
                datasets: dataSets.map((dataSet, index) => {
                    return {
                        label: dataSet.label,
                        data: dataSet.values,
                        borderColor: dataSet.isGreyed ? 'rgba(222, 222, 222, 0.5)' : dataSet.isNegative ? NEGATIVE_CHART_COLORS[0].solid : CHART_COLORS[index]?.solid,
                        backgroundColor: dataSet.isGreyed ? 'rgba(222, 222, 222, 0.5)' : dataSet.isNegative ? NEGATIVE_CHART_COLORS[0].solid : CHART_COLORS[index]?.solid,
                        fill: true,
                    };
                })
            };
        } else return {
            labels: [],
            datasets: [],
        };
    }, [data, isDataLoaded]);

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: {
                        family: 'quicksand-bold'
                    },
                    boxWidth: 12,
                },
            },
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    font: {
                        family: 'quicksand-bold'
                    }
                },
            },
            y: {
                stacked: true,
                ticks: {
                    precision: 0,
                    font: {
                        family: 'quicksand-bold'
                    }
                }
            },
        },
    }

    return <BaseChart
        data={digestedData}
        options={options}
        isDataLoaded={isDataLoaded}
        title={title}
        Chart={Bar}
    />;
}